import { StyledModalText, UIButton } from "common/components";
import { useTrack } from "common/utilities/useTrack";
import { useWeforumUrl } from "common/utilities/useWeforumUrl";
import type { TrackMeta } from "domains/analytics/types";
import { ModalHeader } from "domains/modal/components/ModalHeader";

type UpgradeModalProps = { buttonText: string; buttonTrackMeta: Partial<TrackMeta>; message: string; title: string };

export const UpgradeModal = ({ buttonText, buttonTrackMeta, message, title }: UpgradeModalProps) => {
  const track = useTrack();
  const weforumUrl = useWeforumUrl();

  const onUpgradeHandle = () => {
    track({ ...buttonTrackMeta, name: "Upgrade" });
    open(`${weforumUrl}/join-us/pro-access`);
  };

  return (
    <>
      <ModalHeader title={title} />
      <StyledModalText>{message}</StyledModalText>
      <UIButton fullwidth onClick={onUpgradeHandle} variant="filled">
        {buttonText}
      </UIButton>
    </>
  );
};
